import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { type RootState } from "../../Reducers/ShopfrontReducers";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import { getOption, subscribeToOption, unsubscribeFromOption } from "../../Utilities/Platform/Options/Options";
import DisplayAgent from "../../Workers/CustomerDisplay/DisplayAgent";

const connector = connect((state: RootState) => ({
    visible : !!state.customerDisplay.visible,
    register: !!state.location.register,
}));

type Props = ConnectedProps<typeof connector>;

type State = {
    blink: boolean;
    required: boolean;
};

export class CustomerDisplayIndicator extends React.Component<Props, State> {
    private _blinkInterval: null | ReturnType<typeof setInterval> = null;

    public state = {
        blink   : false,
        required: getOption("register_open_display_on_open_register"),
    };

    public componentDidMount(): void {
        const required = subscribeToOption("register_open_display_on_open_register", this.updateValue);

        if(!this.props.visible && required) {
            this._blinkInterval = setInterval(this.toggleBlink, 1000);
        }
    }

    public componentWillUnmount(): void {
        unsubscribeFromOption("register_open_display_on_open_register", this.updateValue);
    }

    public componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>): void {
        if(
            prevProps.visible !== this.props.visible ||
            prevState.required !== this.state.required ||
            prevProps.register !== this.props.register
        ) {
            if(this._blinkInterval) {
                clearInterval(this._blinkInterval);
            }

            if(!this.props.visible && this.state.required) {
                this._blinkInterval = setInterval(this.toggleBlink, 1000);
            }
        }
    }

    public toggleBlink = (): void => {
        this.setState(prevState => ({
            blink: !prevState.blink,
        }));
    };

    public updateValue = (option: string, value: boolean): void => {
        this.setState({
            required: value,
        });
    };

    public onClick = (e: React.MouseEvent<HTMLDivElement>): void => {
        e.stopPropagation();

        void DisplayAgent.getInstance().openDisplay();
    };

    public render(): React.ReactNode {
        if(!this.state.required || this.props.visible || !this.props.register) {
            return null;
        }

        return (
            <div
                className={"header-item customer-display-indicator" + (this.state.blink ? " blink" : "")}
                onClick={this.onClick}
            >
                <FontAwesomeLight icon="tv" />
            </div>
        );
    }
}

export default connector(CustomerDisplayIndicator);
